/**
 * Utility to map API endpoints to their source application types.
 * 
 * This is used specifically in HRMS (Reporting) mode to identify 
 * which PInstanceID to use for a given request.
 */
const InstanceMapper = {
    // Map of endpoint prefixes/keywords to Application Types
    mapping: {
        // HOMS: Order Management System (Sales)
        HOMS: [
            "/orders",
            "/customers",
            "/sales",
            "/order_items",
            "/inventory",
            "/products",
            "/categories",
            "/status_history"
        ],

        // HPRMS: Procurement & Purchase Management
        HPRMS: [
            "/PurchaseOrderManagement",
            "/VendorManagement",
            "/purchaseOrders",
            "/vendors",
            "/individuals",
            "/organizations",
            "/inventory",
            "/products",
            "/categories",
        ],

        // // HPiMS: Inventory Management
        // HPiMS: [
        //     "/inventory",
        //     "/products",
        //     "/categories",
        //     "/stock",
        //     "/warehouses"
        // ],

        // HPOS: Point of Sale
        HPOS: [
            "/pos",
            "/checkout",
            "/receipts",
            "/hpos/shifts"
        ]
    },

    /**
     * Identifies the application type for a given endpoint.
     * @param {string} endpoint - The API endpoint
     * @returns {string|null} - The application type (e.g., 'HOMS', 'HPRMS') or null
     */
    getAppTypeForEndpoint(endpoint) {
        if (!endpoint) return null;

        for (const [appType, prefixes] of Object.entries(this.mapping)) {
            if (prefixes.some(prefix => endpoint.toLowerCase().includes(prefix.toLowerCase()))) {
                return appType;
            }
        }

        return null;
    }
};

export default InstanceMapper;
